<div class="container indent-background">
  <p>
    We are horror fans, love art and admire the hell out of bloody amazing tattoos. INKfection Collection swirled around in our heads for 
    a while and then was spawned and spit out into the world to satiate dark tastes like ours. Why not make amazingly bloody art centered 
    around the tattoos of other horror fans? We hadn’t seen it done before, so we knew if we found a way to do it, you all would want a 
    piece of it for your own, hence our tagline, “We flay it... you display it!”
  </p>
  <p>
    We also own Little Jars of Horror (<a href="http://www.littlejarsofhorror.com" target="_ljoh">www.littlejarsofhorror.com</a>) and a brick 
    and mortar retail Monster and Horror store called Ghoulish Mortals in the Chicago suburb of St. Charles. 
    (<a href="http://www.ghoulishmortals.com" target="_gm">www.ghoulishmortals.com</a>) We have the INKfection Collection for sale on Etsy and 
    at our store (where we can photograph your tattoo in person). INKfection Collection will be at various horror conventions in the Midwest area.
  </p>
  <p>
    We welcome wholesale orders of a minimum 20 pieces or more for retail stores. We also have a great cross promotion program for tattoo shops. 
    Please inquire if we can assist with either of these options
  </p>
</div>

